// globals: jQuery, __setCreditCardInfo

import CashFlowIframeAbstract from './cashFlowIframeAbstract';

var cashFlowIframeSaveUserCard;

(function($) {
    var __setCreditCardPaymentInfo = function(data) {

        const cardTypeMap = {
            "americanexpress": 'amex',
            "mastercard": 'mastercard',
            "discover": 'discover',
            "visa": 'visa',
        };

        let receivedCardType = null;
        if (data.cc_type) {
            receivedCardType = data.cc_type.toLowerCase();
        }

        const cardType = cardTypeMap[receivedCardType] ? cardTypeMap[receivedCardType] : null;

        const preparedData = {
            paymentProcessorUniqueId: data.cc_merchant_unique_id,
            expirationMonth: data.expiration_month,
            expirationYear: data.expiration_year,
            cardNumber: data.cc_number,
            cardType: cardType,
        };

        __setCreditCardInfo(preparedData);
    };

    cashFlowIframeSaveUserCard = new CashFlowIframeAbstract({
        frameContainer: 'saveUserCard_i4goFrame',
        iframeLocation: 'profile',
        frameAutoResize: false,
        template: undefined,
        iframeStyle: 'style="width:100%;height:auto;"',
        label: {
            classes:"control-label col-xs-4 text-right",
        }
    });

    var __postToParent = function (data) {
        var parentWindow = window.parent;
        if (parentWindow === window) {
            parentWindow = window.opener;
        }

        var parameters = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            parameters[key] = decodeURIComponent(value);
        });

        if (parameters.parentUrl) {
            var parentLocation = parameters.parentUrl;
        }

        let dataPrepared;
        const responseType = 'SUCCESS';
        if (parentLocation && parentWindow) {
            if (data.success === true) {
                dataPrepared = {
                    i4go_uniqueid: data.cc_merchant_unique_id,
                    cc_number: data.cc_number,
                    i4go_expirationyear: data.expiration_year,
                    i4go_expirationmonth: data.expiration_month,
                    i4go_response: responseType
                };
            }
            dataPrepared = {...data, ...dataPrepared};
            parentWindow.postMessage(dataPrepared, parentLocation);
        }
    };

    cashFlowIframeSaveUserCard.onSuccess = function(form, data) {
        __setCreditCardPaymentInfo(data);
        __postToParent(data);

        const cardMustBeSaved = $(form).find('[name=card_on_file]').val();
        if (!cardMustBeSaved) {
            window.close();
            return;
        }

        var url = '/i4go/save-user-card';

        data.ca_token = $(form).find('[name=ca_token]').val();

        $.caPost(
            url,
            data,
            function(response) {
                if (response.status === 1) {
                    window.close();
                } else {
                    $.caAlert(response.error);
                }
            },
            'json',
            true
        );
    };

    cashFlowIframeSaveUserCard.onFailure = function() {
        $.caAlert('Something went wrong... Please try again later.');
    };

})(jQuery);

export default cashFlowIframeSaveUserCard;
